import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "When you can't algorithm, photowalk",
  "description": "",
  "published": "2009-01-04T00:00:00.000Z",
  "redirect_from": ["/blog/when-you-cant-algorithm-photowalk/swizec/23"],
  "categories": "art",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I had a rather frustrating time with some algorithms that were later surprisingly easy to conquer but hey, guess I was stuck and needed a break so I decided to say FUCK YOU to the algorithm and go for a photowalk. It was rather lovely being out there on the snow although when I got to the nearest hill's top the air was strangely foul and stank of smoke. Interestingly enough at ground level it's very nice air ...`}</p>
    <p>{`For the record, I do realise I once promised photowalking on a weekly basis, but I just can't seem to manage that for some reason, must be all that silly work that tends to pile up and the shortnes of days. Pictures are much nicer when taken in well-lit conditions you know.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      